import { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAppStore } from '../store/appStore';
import { useGoogleAuth } from '../store/googleAuthStore';
import { formatTimeRemaining } from '@kidstube/shared';
import './Header.css';

export function Header() {
    const navigate = useNavigate();
    const location = useLocation();
    const { currentProfile, getRemainingSeconds } = useAppStore();
    const { isSignedIn } = useGoogleAuth();
    const [, setTick] = useState(0);

    // Force re-render every second for countdown display
    useEffect(() => {
        const interval = setInterval(() => {
            setTick(t => t + 1);
        }, 1000);
        return () => clearInterval(interval);
    }, []);

    // Get remaining seconds from wall clock calculation
    const remainingSeconds = getRemainingSeconds();

    // Don't show header on player page
    if (location.pathname.startsWith('/watch/')) {
        return null;
    }

    return (
        <header className="header">
            <div className="header__logo-container">
                <Link to="/" className="header__logo">
                    <span className="header__logo-icon">🎬</span>
                    <span className="header__logo-text">KidsTube</span>
                </Link>
                {isSignedIn && (
                    <span className="header__premium-badge">✓ Cloud</span>
                )}
            </div>

            <button
                onClick={() => navigate('/search')}
                className="header__search-btn"
            >
                <span>🔍</span>
                <span>Search...</span>
            </button>

            <div className="header__actions">
                {remainingSeconds > 0 && (
                    <span className={`header__time ${remainingSeconds <= 300 ? 'header__time--warning' : ''}`}>
                        ⏱️ {formatTimeRemaining(remainingSeconds)}
                    </span>
                )}

                {currentProfile && (
                    <div className="header__avatar">
                        {currentProfile.avatarId}
                    </div>
                )}

                <Link to="/parent" className="header__settings">
                    ⚙️
                </Link>
            </div>
        </header>
    );
}
